import { axios } from "@/client/libs/axios";
import { FilterUserType, UserWithSecrets } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import qs from "qs";

export const getFilterAmbassador = async (page?: number, filter?: FilterUserType | null) => {
  if (filter) {
    const user = await axios.get<
      { page: number; data: UserWithSecrets[] },
      AxiosResponse<{ page: number; data: UserWithSecrets[] }>
    >("user", {
      params: {
        page: page,
        role: { equals: 2 },
        ...filter,
      },
      paramsSerializer: (params) => {
        const filterParams = qs.stringify(params);
        sessionStorage.setItem("Current_ambassador_list", filterParams);
        return filterParams;
      },
    });
    return user.data;
  }

  const user = await axios.get<
    { page: number; data: UserWithSecrets[] },
    AxiosResponse<{ page: number; data: UserWithSecrets[] }>
  >("/user", {
    params: {
      page: page,
      role: { equals: 2 },
    },
    paramsSerializer: (params) => {
      const filterParams = qs.stringify(params);
      sessionStorage.setItem("Current_ambassador_list", filterParams);
      return filterParams;
    },
  });

  return user.data;
};

export const useFilterAmbassador = (page?: number, filter?: FilterUserType | null) => {
  const { data: filterAmbassador, error } = useQuery({
    queryKey: ["filter-ambassador", page, filter],
    queryFn: () => getFilterAmbassador(page, filter),
  });

  return { filterAmbassador, error };
};
